import { useEffect, useRef, useState } from "react";
import { useAnimationState } from "moti";
import { CardCollapseProps, CardCollapseVariant } from "./types";
import { CardCollapseVariantsThemeMap } from "./constants";

export const useCardCollapseController = ({
  variant = CardCollapseVariant.success,
  isLoading = false
}: Pick<CardCollapseProps, "variant" | "isLoading">) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [contentHeight, setContentHeight] = useState(0);
  // Note: Moti not provider type to ref
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const contentRef = useRef<any>(null);

  const animationState = useAnimationState({
    from: {
      height: 0,
      opacity: 0
    },
    to: {
      height: contentHeight || 1,
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  });

  useEffect(() => {
    animationState.transitionTo("from");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isCollapsed && contentHeight > 0) {
      animationState.transitionTo("to");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentHeight]);

  const toggleCollapse = () => {
    const newCollapsedState = !isCollapsed;
    setIsCollapsed(newCollapsedState);

    if (newCollapsedState) {
      animationState.transitionTo("from");
    } else {
      if (contentHeight > 0) {
        animationState.transitionTo("to");
      } else {
        // Wait for layout measurement
        setTimeout(() => {
          animationState.transitionTo("to");
        }, 50);
      }
    }
  };

  const handleCollapseContentLayout = (event: any) => {
    const { height } = event.nativeEvent.layout;
    if (height > 0 && height !== contentHeight) {
      setContentHeight(height);
    }
  };

  const { icon, iconColor, ...theme } = CardCollapseVariantsThemeMap[variant];
  const borderColor = isLoading ? "$borderLight100" : theme.borderColor;

  return {
    contentRef,
    contentHeight,
    isCollapsed,
    borderColor,
    icon,
    iconColor,
    toggleCollapse,
    handleCollapseContentLayout,
    animationState
  };
};
